/**
 * Google Analytics 4.
 *
 * 가입한 뒤의 일은 GA 로 재지 않는다 — 담은 책·문장·좌표는 DB 가 이미
 * 더 정확히 알고 있다. GA 는 DB 가 볼 수 없는 것만 본다.
 *   방문 → 가입 전환, 어디서 들어왔는지, 다시 돌아왔는지.
 *
 * 책 제목·사용자 id 는 보내지 않는다. 남의 서버에 있을 이유가 없는 값이다.
 */
const ID = "G-VQXE7BGPF6";

let on = false;

export function initAnalytics() {
  if (on) return;
  /* 개발 중 화면 전환까지 섞이면 실제 방문 수를 읽을 수 없다 */
  if (process.env.NODE_ENV !== "production") return;
  if (typeof window === "undefined") return;
  on = true;

  /* dataLayer 는 스크립트가 오기 전에 쌓아두면 나중에 한꺼번에 처리된다.
     그래서 초기화 직후의 이벤트도 잃지 않는다. */
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  /* 자동 page_view 를 끈다. 이 앱은 pushState 로 화면을 바꾸는 한 장짜리라,
     켜두면 처음 열 때 한 번만 찍히고 그 뒤 이동은 전부 보이지 않는다. */
  window.gtag("config", ID, { send_page_view: false });

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ID}`;
  document.head.appendChild(s);
}

/** 화면 하나를 한 번 본 것으로 센다. screen 은 'home' 같은 내부 이름이다. */
export function pageView(screen) {
  if (!on || !window.gtag || !screen || screen === "loading") return;
  window.gtag("event", "page_view", {
    page_path: `/${screen}`,
    page_title: screen,
    page_location: `${window.location.origin}/${screen}`,
  });
}

/** 값이 필요한 순간만 짚는다. 무엇이든 다 보내면 나중에 읽을 수 없다. */
export function track(name, params = {}) {
  if (!on || !window.gtag) return;
  window.gtag("event", name, params);
}
